import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { api } from '../utils/api';
import { useI18n } from '../i18n/I18nProvider';

const ERROR_KEYS = {
  token_already_used: 'resetPassword.used',
  token_expired:      'resetPassword.expired',
  invalid_token:      'resetPassword.invalid',
};

// ResetPasswordPage consumes the reset link: it reads ?token and sets a new
// password via POST /v1/auth/password/reset (PIN-225).
const ResetPasswordPage = () => {
  const [params] = useSearchParams();
  const token = params.get('token');
  const { t } = useI18n();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [error, setError]       = useState('');
  const [done, setDone]         = useState(false);
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError(t('resetPassword.tooShort')); return; }
    if (password !== confirm) { setError(t('resetPassword.mismatch')); return; }
    setLoading(true);
    try {
      const res = await api.resetPassword(token, password);
      if (res.ok) { setDone(true); return; }
      const d = await res.json().catch(() => ({}));
      setError(t(ERROR_KEYS[d.error] || 'resetPassword.failed'));
    } catch {
      setError(t('auth.connectionError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="uh-login-container">
      <div className="uh-card" style={{ width: 'min(440px, 94vw)', padding: 32 }}>
        <div className="uh-login-subtitle" style={{ marginBottom: 16, textAlign: 'center' }}>{t('app.brand')}</div>
        <h1 className="uh-title" style={{ fontSize: 22, marginBottom: 16 }}>{t('resetPassword.title')}</h1>

        {done ? (
          <>
            <div className="uh-alert-success">{t('resetPassword.done')}</div>
            <button className="uh-btn uh-btn-primary" style={{ marginTop: 16 }} onClick={() => navigate('/login', { replace: true })}>
              {t('resetPassword.toLogin')}
            </button>
          </>
        ) : !token ? (
          <>
            <div className="uh-alert-error">{t('resetPassword.invalid')}</div>
            <Link className="uh-btn" to="/login" style={{ marginTop: 16 }}>{t('resetPassword.toLogin')}</Link>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && <div className="uh-alert-error">{error}</div>}
            <div className="uh-form-group">
              <label className="uh-label">{t('resetPassword.newPassword')}</label>
              <input className="uh-input" type="password" value={password} autoFocus
                onChange={e => setPassword(e.target.value)} required disabled={loading} />
            </div>
            <div className="uh-form-group">
              <label className="uh-label">{t('resetPassword.confirm')}</label>
              <input className="uh-input" type="password" value={confirm}
                onChange={e => setConfirm(e.target.value)} required disabled={loading} />
            </div>
            <button type="submit" className="uh-btn uh-btn-primary" style={{ width: '100%' }} disabled={loading}>
              {loading ? t('common.saving') : t('resetPassword.submit')}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordPage;
